import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund API
 */
class FundApi extends ApiBase {
  /**
   * Check if fund ID already exists
   * @param {*} fundId
   */
  async checkIdExists(fundId) {
    const request = {
      url: `${this.API_URL}/fund?id=${fundId}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return status === 200 || status === 403 || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  /**
   * update funds
   * @param {*} funds
   */
  async update(funds) {
    const request = {
      url: `${this.API_URL}/funds`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(funds)
    };

    const response = await axios.request(request);

    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/fund/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async importFundsFromExcel(payload, options = {}) {
    const request = {
      url: `${this.API_URL}/fund/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      params: {
        ...options
      },
      data: payload
    };

    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async downloadFundImportTemplate() {
    const request = {
      url: `${this.API_URL}/fund/import/template`,
      method: 'GET',
      headers: this.getHeaders(),
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response.data;
  }

  async exportFundsExcel(
    fundId,
    fundName,
    fundFamilyId,
    fundTagId,
    status,
    selectedIds
  ) {
    let payload;
    if (selectedIds && selectedIds.length > 0) {
      payload = {
        id: `[${selectedIds.join(',')}]`
      };
    } else {
      payload = {
        id: fundId,
        name: fundName,
        fundFamilyId: fundFamilyId,
        fundTagId: fundTagId,
        status: status
      };
    }

    const request = {
      url: `${this.API_URL}/funds/excel/export`,
      method: 'POST',
      headers: this.getHeaders(),
      responseType: 'blob',
      data: payload
    };

    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async create(payload, id, options = {}) {
    const request = {
      url: `${this.API_URL}/fund`,
      method: 'POST',
      headers: this.getHeaders(),
      params: {
        id: id,
        ...options
      },
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }

  async edit(payload, id) {
    const request = {
      url: `${this.API_URL}/fund?id=${id}`,
      method: 'PUT',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }

  async getAll() {
    const request = {
      url: `${this.API_URL}/funds?returnFundTags=true`,
      method: 'GET',
      headers: this.getHeaders()
    };

    const response = await axios.request(request);
    return response.data;
  }

  async getFundsByIds(ids) {
    let formattedIds = '';
    if (ids) {
      formattedIds = `[${ids.join(',')}]`;
    }

    const request = {
      url: `${this.API_URL}/funds?id=${encodeURIComponent(formattedIds)}`,
      method: 'GET',
      headers: this.getHeaders()
    };

    const response = await axios.request(request);
    return response.data;
  }
}

export default new FundApi();
